module.exports = __webpack_public_path__ + "img/redo.029554f9.svg";